/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';
import classnames from 'classnames';
import { reaction } from 'mobx';
// import { observer } from 'mobx-react';
import { Drawer, IModuleProps, INodeProps, Module } from '@msdyn365-commerce-modules/utilities';
import { ProductApplicationTableRow } from './components/product-custom-application-table-stucture';
 import {getProductApplicationInputAsync } from '../../actions/getProductApplication';
 export interface IProductApplicationState {
    isDrawerOpen: boolean;
    drawerListId: number | undefined;
}

import { IGeneraProductApplicationData } from './genera-product-application.data';
import { IGeneraProductApplicationProps, displayStyle } from './genera-product-application.props.autogenerated';


/**
 *
 * GeneraProductApplication component
 * @extends {React.PureComponent<IGeneraProductApplicationProps<IGeneraProductApplicationData>>}
 */
// class GeneraProductApplication extends React.PureComponent<IGeneraProductApplicationProps<IGeneraProductApplicationData>> {
//     public render(): JSX.Element | null {
//         return this.props.renderView(this.props);
//     }
// }

// export default GeneraProductApplication;


export interface IGeneraProductApplicationViewProps extends IGeneraProductApplicationProps<IGeneraProductApplicationData> {
    ProductSpecification: IModuleProps;
    ProductSpecificationTableProps: INodeProps;
    ProductSpecificationTableBodyProps: INodeProps;
    ProductSpecificationTableHeadProps: INodeProps;
    productSpecificationResult?: (JSX.Element | null)[];
    productApplicationTableHead?: (JSX.Element | null);
    title?: React.ReactNode;
    isAccrodion?: boolean;
    handleText?(event: Msdyn365.ContentEditableEvent): void;
}

export interface IGeneraProductApplicationExtentedProps extends IGeneraProductApplicationProps<IGeneraProductApplicationData> {
    displayStyle?: displayStyle;
}

/**
 *
 * GeneraProductDetails component
 * @extends {React.PureComponent<IGeneraProductAdditionalDetailsProps<IGeneraProductApplicationData>>}
 */

class GeneraProductApplication extends React.PureComponent<IGeneraProductApplicationExtentedProps,IProductApplicationState> {
    public constructor(props: IGeneraProductApplicationExtentedProps) {
        super(props);
        this.state = {
            isDrawerOpen: false,
            drawerListId: undefined
        };
    }

    public async componentDidMount(): Promise<void> {
        const { context, data } = this.props;
        reaction(
            () => (data.product && data.product.result ? data.product.result.RecordId : null),
            () => {
                if (context && data.product.result && (this.props.data.generaProductApplicationData === undefined ||(this.props.data.generaProductApplicationData && this.props.data.generaProductApplicationData.result === undefined)) ) {
                    this.getProductApplicationData();
                }
            }
        );
    }

    public async getProductApplicationData(): Promise<void>{
        getProductApplicationInputAsync({callerContext: this.props.context.actionContext},this.props.data.product?.result!.RecordId).then(data=>{
            this.props.data.generaProductApplicationData.result = data;
         }).catch((error: Error) => {
        });
    }

    public shouldComponentUpdate(nextProps: IGeneraProductApplicationExtentedProps,
        nextState: IProductApplicationState): boolean {
        if (this.state === nextState && this.props.data === nextProps.data) {
            return false;
        }
        return true;
    }

    public render(): JSX.Element | null {
        let data: IGeneraProductApplicationData;
        try {
            data = this.props.data;
        } catch (error) {
            this.props.telemetry.error(`Something went wrong ------${error}`);
            return (<div>
                {error}
            </div>);
        }

        if (!data.generaProductApplicationData || (!data.generaProductApplicationData.result || data.generaProductApplicationData.result.length <= 0) && data.generaProductApplicationData.status !== 'LOADING') {
            this.props.telemetry.error('Product vehicle content is empty, module wont render.');
            return null;
        }

        const { heading, className } = this.props.config;
        const { generaProductApplicationData } = this.props.data;

        const isAccrodion = this.props.config.displayStyle === displayStyle.accordion;
        const viewProps = {
            ...this.props,
            handleText: this.handleHeadingChange,
            ProductSpecification: {
                moduleProps: this.props,
                className: classnames('ms-product-specification', className)
            },
            ProductSpecificationTableProps: isAccrodion ? {
                moduleProps: this.props,
                className: classnames('ms-product-specification__accordion', className)
            } : {
                className: classnames('ms-product-specification__table table-striped table-bordered'),
                tag: 'table'
            },
            isAccrodion,
            ProductSpecificationTableBodyProps: isAccrodion ? {} : {
                className: '',
                tag: 'tbody'
            },
            ProductSpecificationTableHeadProps: isAccrodion ? {} : {
                className: '',
                tag: 'thead'
            },
            title: heading?.text && (
                <Msdyn365.Text
                    className='ms-product-specification__heading'
                    tag={heading.tag ?? 'h2'}
                    text={heading.text}
                    editProps={{ onEdit: this.handleHeadingChange, requestContext: this.props.context.request }}
                />),
                productApplicationTableHead: isAccrodion? <></> : this._createTableHeader() ,
            productSpecificationResult: isAccrodion ? generaProductApplicationData.result && this._createDrawerBody(data) : generaProductApplicationData.result && this._createTableBody(data)
        } as IGeneraProductApplicationViewProps;

        return this.props.renderView(viewProps) as React.ReactElement;
    }


    /**
     * Handle Heading Text Change.
     * @param event - Current event.
     */
     public handleHeadingChange = (event: Msdyn365.ContentEditableEvent): void => {
        this.props.config.heading!.text = event.target.value;
    };

    private _createTableBody(content: IGeneraProductApplicationData): (JSX.Element | null)[] {

        return content.generaProductApplicationData && content.generaProductApplicationData.result && content.generaProductApplicationData.result.length > 0 ?content.generaProductApplicationData.result.map((product, index) => {


            return (
                <ProductApplicationTableRow
                    className='ms-product-specification__table-row'
                    key={index}
                    make={product.Make}
                    model={product.Model}
                    year={product.Year}
                    qualifier={product.Qualifier}
                    note={product.Note}
                    //cellData={cellData}
                />
            );
        }) : [];
    }

    private _createTableHeader(): (JSX.Element) {
            return (
                <tr  key={0}  className='ms-product-specification__table-row'>
                    <th>Make</th>
                    <th>Model</th>
                    <th>Year</th>
                    <th>Qualifiers</th>
                    <th>Note</th>
                    </tr>
            );
    }


    private _createDrawerBody(content: IGeneraProductApplicationData): (JSX.Element | null)[] {

        const accordionItemContainer: IModuleProps = {
            moduleProps: this.props,
            className: 'ms-product-specification-title'
        };
        return content.generaProductApplicationData.result!.map((product) => {
            return (
                <Module {...accordionItemContainer} key={product.RecordId}>
                    <Drawer
                        key={product.RecordId}
                        collapseProps={
                            {
                                timeout: 0,
                                isOpen: this.state.isDrawerOpen && this.state.drawerListId === product.RecordId
                            }
                        }
                        className='ms-product-specification__drawer'
                        openGlyph='ms-product-specification__drawer-open'
                        closeGlyph='ms-product-specification__drawer-close'
                        glyphPlacement='end'
                        toggleButtonText={product.Make ?? ''}
                        onToggle={this._toggle(product.RecordId)}
                    >
                        <div className='ms-product-details'>
                            {/* {cellData} */}
                        </div>
                    </Drawer>
                </Module>
            );
        });
    }

    private readonly _toggle = (drawerListId: number | undefined) => (): void => {
        if (this.state.drawerListId !== drawerListId) {
            this.setState({ drawerListId, isDrawerOpen: true });
        } else {
            this.setState({ drawerListId: undefined, isDrawerOpen: false });
        }
    };


}

export default GeneraProductApplication;